import { isSameDay } from '@utils';
import { groupBy } from 'lodash-es';

export const TASKS_PER_COLUMN = 4;

export const handleDriversTask = (tasks, driver, date) =>
  tasks
    .filter((task) => isSameDay(new Date(task?.customFields?.startDate), date))
    .filter(
      (task) =>
        task.customFields?.primaryDriver === driver.email ||
        task.customFields?.secondaryDriver === driver.email
    )
    .sort((a, b) => {
      const startDateA = new Date(a?.customFields?.startDate)?.getTime();
      const startDateB = new Date(b?.customFields?.startDate)?.getTime();
      return startDateA - startDateB || 0;
    })
    .map((task, index) => ({
      ...task,
      column: Math.floor(index / TASKS_PER_COLUMN),
    }));

export const handleAddColumns = (data = {}) =>
  Object.keys(data).reduce((acc, cur) => {
    const columns = groupBy(data[cur].tasks, 'column');
    acc[cur] = { ...data[cur], columns };
    return acc;
  }, {});

export const handleLogisticsDriversData = ({
  logistics = [],
  assignees = [],
  date,
}) => {
  const data = assignees.reduce((acc, cur) => {
    if (cur.value) {
      acc[cur.value] = {
        driver: {
          ...cur,
          fullName: cur?.text,
          shortName: cur?.shortName,
        },
        tasks: handleDriversTask(logistics, cur, date),
      };
    }
    return acc;
  }, {});

  return handleAddColumns(data);
};

export const getMaxColumns = (data) =>
  Math.max(
    ...Object.values(data).map(
      (entry) => Object.keys(entry.columns || {}).length
    )
  );

export const calcTotalDrivers = (driverObj) => {
  if (!driverObj || !Object.keys(driverObj).length) return 0;
  return Object.values(driverObj).reduce((acc, cur) => {
    acc += cur.driver ? 1 : 0;
    return acc;
  }, 0);
};
